<div class="modal-header ">
    <!-- p-0 py-2 px-3 -->
    <!-- <h4 class="modal-title text-center" id="myCenterModalLabel">Forget Password</h4> -->
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body" [formGroup]="forgetPasswordForm">
    
    <div class="d-flex justify-content-center w-100">
        <div *ngIf="showErrorMessage" class="bg-danger-subtle d-flex justify-content-between p-1 mb-1 w-100">
            <div>
                <span class="spanText text-danger-emphasis">
                    <i class="fs-3 ti ti-bomb"></i> {{ currentMessage }}
                </span>
            </div>
            <div class="d-flex">
                <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"
                    (click)="close()"></button>
            </div>
        </div>
    </div>
    <app-input-static-fields 
    htmlCode="" 
    code="ti ti-at"
        [formGroup]="forgetPasswordForm"
        label="{{ translate('EMAILADDRESS') }}" 
        placeholder="Abc.caregenix.solution@gmail.com"
        [name]="'Email'"
        type="email"
        [formControlValue]="'email'"    
    />
    <p class="forgetPasswordHint">Please check your email to reset your password.</p>
    <div class=" py-3">
        <button 
          class="btn btn-lg w-100 btnForgetPassword"
          type="submit"
          (click)="onSubmit()"
          [disabled]="forgetPasswordForm.invalid">Send</button>
    </div>
  
</div>